<template>
  <div class="breadcrumb-container">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li
          v-for="(item, index) in itemsResolvidos"
          :key="index"
          class="breadcrumb-item"
        >
          <router-link
            v-if="item.to && index !== itemsResolvidos.length - 1"
            :to="item.to"
          >
            <span
              v-if="item.carregando"
              class="breadcrumb-skeleton"
            ></span>
            <span v-else>{{ limitarTexto(item.label, 25) }}</span>
          </router-link>

          <span
            v-else
            :title="item.label"
          >
            <span
              v-if="item.carregando"
              class="breadcrumb-skeleton"
            ></span>
            <span v-else>{{ limitarTexto(item.label, 25) }}</span>
          </span>
        </li>
      </ol>
    </nav>
  </div>
</template>

<script>
import acaoService from "@/service/acaoService";
import { limitarTexto } from "@/utils/FormatarEntradas";

const RESOLVERS = {
  acao: (id) => acaoService.getAcoesById(id).then((res) => res.titulo),
};

export default {
  name: "Breadcrumb",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      itemsResolvidos: [],
    };
  },
  watch: {
    items: {
      immediate: true,
      handler() {
        this.resolverItems();
      },
    },
  },
  methods: {
    async resolverItems() {
      this.itemsResolvidos = this.items.map((item) => ({
        label: item.tipo ? "" : item.label,
        to: item.to,
        carregando: !!item.tipo,
      }));

      this.items.forEach((item, index) => {
        if (!item.tipo) return;

        // Guarda: se o id ainda não chegou, mantém "carregando" e não faz a requisição.
        // Quando o pai atualizar o id (ex: acaoId deixar de ser undefined), o watch
        // em "items" vai disparar resolverItems() de novo automaticamente.
        if (item.id === undefined || item.id === null || item.id === "") {
          this.itemsResolvidos[index] = {
            ...this.itemsResolvidos[index],
            carregando: true,
          };
          return;
        }

        const chaveCache = `${item.tipo}:${item.id}`;

        // Evita repetir a mesma requisição se resolverItems rodar de novo
        // (ex: outro item do array mudou) enquanto esta já está em andamento ou pronta.
        if (this._cacheResolvidos && this._cacheResolvidos[chaveCache]) {
          this.itemsResolvidos[index] = {
            ...this.itemsResolvidos[index],
            label: this._cacheResolvidos[chaveCache],
            carregando: false,
          };
          return;
        }

        const resolver = RESOLVERS[item.tipo];
        if (!resolver) {
          console.warn(
            `Breadcrumb: nenhum resolver encontrado para o tipo "${item.tipo}"`
          );
          this.itemsResolvidos[index] = {
            ...this.itemsResolvidos[index],
            label: item.fallback || "—",
            carregando: false,
          };
          return;
        }

        resolver(item.id)
          .then((nome) => {
            this._cacheResolvidos = this._cacheResolvidos || {};
            this._cacheResolvidos[chaveCache] = nome;

            this.itemsResolvidos[index] = {
              ...this.itemsResolvidos[index],
              label: nome,
              carregando: false,
            };
          })
          .catch((error) => {
            console.error(
              `Breadcrumb: erro ao buscar item do tipo "${item.tipo}"`,
              error
            );
            this.itemsResolvidos[index] = {
              ...this.itemsResolvidos[index],
              label: item.fallback || "—",
              carregando: false,
            };
          });
      });
    },
    limitarTexto,
  },
};
</script>

<style scoped></style>
